import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '@services/user.service';

@Component({
	selector: 'app-invite',
	templateUrl: './invite.component.html',
	styleUrls: ['./invite.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class InviteComponent {
	theme: string = 'my-light-theme';

	constructor(
		private router: Router,
		private userService: UserService,
	) {
		this.userService.fetchAccountsObs().subscribe(() => {});
	}

	logout() {
		void this.router.navigate(['signin']);
	}
}
